<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addRecommendation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #267d26">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            v-if="users"
            col="12"
            :optionsList="users"
            :placeholder="$t('SIDENAV.Clients.name')"
            v-model="data.user"
            required
          />

          <!-- Start:: Recommendations Repeater -->
          <div class="col-12">
            <div
              class="row align-items-center"
              v-for="(item, index) in data.recommendations"
              :key="index"
            >
              <base-select-input
                col="5"
                :optionsList="recommendationLists"
                :placeholder="$t('PLACEHOLDERS.recommendation_list')"
                v-model="item.recommendation_list_id"
                required
              />
              <base-select-with-scroll
                col="5"
                :optionsList="influencers"
                :placeholder="$t('PLACEHOLDERS.influencer_name')"
                v-model="item.influencer"
                required
                :disabled="!influencers"
                :style="!influencers ? 'cursor: wait;' : ''"
                :hasMore="influencersHasMore"
                :isLoading="influencersLoading"
                @loadMore="loadMoreInfluencers"
              />
              <div class="col-2">
                <div class="d-flex align-center justify-start h-100">
                  <v-btn
                    fab
                    x-small
                    color="error"
                    class="mx-1"
                    @click="removeRow(index)"
                    v-if="data.recommendations.length > 1"
                    elevation="0"
                  >
                    <i class="fas fa-minus white--text"></i>
                  </v-btn>
                  <v-btn
                    fab
                    x-small
                    color="success"
                    class="mx-1"
                    @click="addRow"
                    v-if="index === data.recommendations.length - 1"
                    elevation="0"
                  >
                    <i class="fas fa-plus white--text"></i>
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- <div class="col-12 mt-2">
              <v-btn color="primary" @click="addRow">
                <v-icon left>mdi-plus</v-icon> {{ $t("BUTTONS.add_row") }}
              </v-btn>
            </div> -->
          </div>
          <!-- End:: Recommendations Repeater -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CreateRecommendation",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      users: [],
      influencers: [],
      recommendationLists: [],

      // Influencers Pagination
      influencersPage: 1,
      influencersHasMore: true,
      influencersLoading: false,

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        user: null,
        recommendations: [
          {
            recommendation_list_id: null,
            influencer: null,
          },
        ],
      },
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: Repeater Methods
    addRow() {
      this.data.recommendations.push({
        recommendation_list_id: null,
        influencer: null,
      });
    },
    removeRow(index) {
      this.data.recommendations.splice(index, 1);
    },
    // End:: Repeater Methods

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.user) {
        REQUEST_DATA.append("user_id", this.data.user?.id);
      }

      this.data.recommendations.forEach((item, index) => {
        if (item.recommendation_list_id) {
          REQUEST_DATA.append(
            `recommendations[${index}][recommendation_list_id]`,
            item.recommendation_list_id?.id || item.recommendation_list_id
          );
        }
        if (item.influencer) {
          REQUEST_DATA.append(
            `recommendations[${index}][influencer_id]`,
            item.influencer?.id
          );
        }
      });

      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `recommendations`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/recommendations/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Get Users
    async getUsers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "clients?page=0&limit=0&is_active=1",
        });
        this.users = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name || item.email,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Users
    // Start:: Get Influencers
    async getInfluencers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `influencers?page=${this.influencersPage}&limit=20&is_active=1`,
        });
        const newInfluencers = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name || item.nick_name,
          ...item,
        }));
        this.influencers = newInfluencers;
        this.influencersHasMore = newInfluencers.length === 20;
        this.influencersPage = 1;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Influencers

    // Start:: Load More Influencers
    async loadMoreInfluencers() {
      if (this.influencersLoading || !this.influencersHasMore) return;

      try {
        this.influencersLoading = true;
        this.influencersPage++;
        let res = await this.$axios({
          method: "GET",
          url: `influencers?page=${this.influencersPage}&limit=20&is_active=1`,
        });
        const newInfluencers = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name || item.nick_name,
          ...item,
        }));
        this.influencers.push(...newInfluencers);
        this.influencersHasMore = newInfluencers.length === 20;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      } finally {
        this.influencersLoading = false;
      }
    },
    // End:: Load More Influencers

    // Start:: Get Recommendation Lists
    async getRecommendationLists() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "recommendation-lists?limit=0&page=0",
        });
        this.recommendationLists = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name_ar || item.name || item.name_en,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Recommendation Lists
  },
  mounted() {
    this.getUsers();
    this.getInfluencers();
    this.getRecommendationLists();
  },
};
</script>
